var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.24,
    height: 69.43,
    viewBox: "0 0 69.24 69.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.42,34.42h-13.78c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h12.95V8.61l-6.96-6.96-52.39.37L1.65,8.61v24.16h12.95c.46,0,.82.37.82.82s-.37.82-.82.82H.82c-.46,0-.82-.37-.82-.82V8.27c0-.22.09-.43.24-.58L7.32.61c.15-.15.36-.24.58-.24l53.07-.37c.2,0,.43.09.59.24l7.45,7.45c.15.15.24.36.24.58v25.32c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.16,25.67c-.46,0-.82-.37-.82-.82v-9.23H8.91v9.23c0,.46-.37.82-.82.82s-.82-.37-.82-.82v-10.06c0-.46.37-.82.82-.82h53.07c.46,0,.82.37.82.82v10.06c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64,49.32H14.6c-.46,0-.82-.37-.82-.82v-27.19c0-.46.37-.82.82-.82s.82.37.82.82v26.36h38.39v-25.62c0-.46.37-.82.82-.82s.82.37.82.82v26.44c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.16,69.43c-.46,0-.82-.37-.82-.82v-35.01c0-.46.37-.82.82-.82s.82.37.82.82v35.01c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.44,69.43h-8.57c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h8.57c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09,69.43c-.46,0-.82-.37-.82-.82v-35.01c0-.46.37-.82.82-.82s.82.37.82.82v35.01c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.37,69.43H3.8c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h8.57c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.16,57.53H8.09c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h53.07c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.78,41.03c-.34,0-.66-.21-.78-.56l-5.1-14.8h-2.55l-5.1,14.8c-.15.43-.62.66-1.05.51-.43-.15-.66-.62-.51-1.05l5.29-15.36c.11-.33.43-.56.78-.56h3.72c.35,0,.66.22.78.56l5.29,15.36c.15.43-.08.9-.51,1.05-.09.03-.18.05-.27.05Z",
    fill: "red",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.72,35.07h-10.26c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h10.26c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormats);
export default __webpack_public_path__ + "static/media/formats.c85a03e50787df46a6add8ab4aa01a86.svg";
export { ForwardRef as ReactComponent };